
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building-site",
      function () {
        return require("private-next-pages/building-site.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building-site"])
      });
    }
  